
export const recurseNodes = (node: Node, cb: (node: Node) => void) => {
  Array.from(node.childNodes).forEach(child => {
    cb(child);
    recurseNodes(child, cb);
  });
};
